import { useFormik } from "formik";
import React from "react";
import {
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import MediaGroupService from "../../../services/KangarooServices/MediaGroupService";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const MediaGroupForm = ({ isOpen, toggle, selectedItem, fetchCategories }) => {

  const validationSchema = Yup.object({
    name: Yup.string().trim().required("Name is required"),

    description: Yup.string().trim()
  });
  const formik = useFormik({
    initialValues: {
      name: selectedItem?.name || "",
      description: selectedItem?.description || "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        if (selectedItem?.id) {
          const response = await MediaGroupService.update(
            selectedItem?.id,
            values
          );
          toast.success("Updated successfull.");
        } else {
          const response = await MediaGroupService.create(values);
          toast.success("Created successfull.");
        }
        fetchCategories();
        toggle();
      } catch (error) {
        console.log(error);
      }
    },
  });
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Media Group</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <FormGroup className="mb-3">
            <Label htmlFor="title">
              Name <span className="text-danger">*</span>
            </Label>
            <Input
              id="name"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.name && !!formik.errors.name}
            />
            {formik.touched.name && formik.errors.name && (
              <FormFeedback>{formik.errors.name}</FormFeedback>
            )}
          </FormGroup>
          <FormGroup className="mb-3">
            <Label>
              Description <span className="text-danger"></span>
            </Label>
            <Input
              id="description"
              name="description"
              type="textarea"
              rows={6}
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={
                formik.touched.description && !!formik.errors.description
              }
            />
            {/* Custom error display for CKEditor description */}
            {formik.touched.description && formik.errors.description && (
              <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
                {formik.errors.description}
              </div>
            )}
          </FormGroup>

          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {selectedItem?.id ? "Update" : "Create"}
            </button>
            <button type="button" className="btn btn-danger" onClick={toggle}>
              Cancel
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default MediaGroupForm;
